import { render, staticRenderFns } from "./PrizeWinner.vue?vue&type=template&id=123246c7&scoped=true&"
import script from "./PrizeWinner.vue?vue&type=script&lang=js&"
export * from "./PrizeWinner.vue?vue&type=script&lang=js&"
import style0 from "./PrizeWinner.vue?vue&type=style&index=0&id=123246c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123246c7",
  null
  
)

export default component.exports